module.exports = __webpack_public_path__ + "static/media/ECI88_Comssion.45d79082.png";